module.exports = __webpack_public_path__ + "b2021a2d7072599b996dc3cb6c7cf61a.svg";